import React from "react";
import { useRecordContext, Button } from "react-admin";
import { Box, Drawer, Typography } from "@mui/material";
import { Column } from "../../ra-lb-tools/components/column";

export const ActionsDrawer = ({ title, children, ...props }) => {
  const record = useRecordContext();
  const [open, setOpen] = React.useState(false);

  if (!record) return null;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        aria-label="more"
        onClick={handleOpen}
        size="small"
        title={title}
        {...props}
      />

      <Drawer anchor="right" open={open} onClose={handleClose}>
        <Box sx={{ padding: 5, textAlign: "center", marginBottom: 10 }}>
          <Typography variant="h6">{title}</Typography>
        </Box>

        <Column sx={{ width: 280, gap: 10 }}>{children}</Column>
      </Drawer>
    </>
  );
};
